<template>
  <div class="factory">
    <nav-header :navs="4" :navsitems="a"/>
    <div class="contents">
      <div class="in-banner">
        <div class="swiper-centers">
          <swiper class="swiper-container" :options="swiperOption">
            <swiper-slide v-for="(item, index) in slideList" :key="index">
              <img :src="item.image" alt="" width="100%" height="auto" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

      <div class="pageBox waps">
        <div class="pagetits">{{ Factorys.title }}</div>
        <div class="pagetops">
          <div class="top-left">
            <img style="width: 100%; height: auto" :src="Factorys.image" />
          </div>
          <div class="top-right">类型：{{ Factorys.typename }}</div>
        </div>
        <div class="gsjs clearfix animation srcospcur">
          <div v-html="Factorys.maincontent"></div>
        </div>
        <div class="xqpage">
          <div class="res" @click="backs()">返回</div>
        </div>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
  <script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ApiCon from "../util/Api/index";
import "swiper/css/swiper.css";
export default {
  name: "about",
  data() {
    return {
      a:'',
      id: this.$route.params.id,
      Factorys: [],
      currentPage: 1, // 当前页码
      pageSize: 12, // 每页显示的行数
      total: 0,
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 4000,
        cubeEffect: {
          shadowOffset: 100,
          shadowScale: 0.6,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      slideList: [
        {
          id: "43",
          image: "http://www.jiukaist.com/images/banner/2.png",
        },
        {
          id: "43",
          image: "http://www.jiukaist.com/images/banner/1.png",
        },
      ],
    };
  },
  components: {
    NavHeader,
    NavFooter,
    Swiper,
    SwiperSlide,
  },
  mounted() {},
  created() {
    let self = this;
    document.documentElement.scrollTop = "0px";
    self.init();
  },
  methods: {
    backs() {
      history.go(-1);
    },
    init() {
      let self = this;
      this.$api.mall
        .getProductDetail({
          id: self.id,
        })
        .then((ress) => {
          let res = ress.data.data;
          console.log(res, "Ssbbb");
          self.Factorys = res;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.factory {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
      content: '' !important;
  }
  .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: '' !important;
}
  .swiper-button-next{
    background: url(../../public/imgs/right-c.png) no-repeat center;
    opacity: 0.7;
    width: 36px;
    height: 36px;
    background-size: 36px;
  }
  .swiper-button-prev{
    background: url(../../public/imgs/left-c.png) no-repeat center;
    width: 36px;
    opacity: 0.7;
    height: 36px;
    background-size: 36px;
  }
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 1s ease;
  }
  .contents {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
    .pagetops {
      width: 100%;
      overflow: hidden;
      margin: 10px auto;
      padding: 0px;
      .top-left {
        width: 480px;
        overflow: hidden;
        margin: 0px auto;
        display: block;
        float: left;
      }
      .top-right {
        width: 380px;
        overflow: hidden;
        margin: 0px auto;
        display: block;
        float: right;
        font-size: 16px;
        line-height: 1.8em;
        color: #333333;
      }
    }
    .xqpage {
      width: 100%;
      margin-top: 30px;
      overflow: hidden;
      border-top: 1px dashed #dcdcdc;
      .res {
        display: block;
        margin-top: 30px;
        margin-bottom: 20px;
        width: 80px;
        line-height: 30px;
        border-bottom: 1px solid #72a3ce;
        background: #005bac;
        color: #fff;
        cursor: pointer;
        font-size: 12px;
        text-align: center;
      }
    }
    .el-pages {
      width: 100%;
      margin: 20px auto;
      overflow: hidden;
      text-align: center;
    }
    .waps {
      width: 90%;
      max-width: 888px;
      overflow: hidden;
      margin: 0 auto;
    }
    .pageBox {
      padding: 4% 0 2%;
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      .Factorys-centers {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        box-sizing: border-box;
        padding: 8px;
        .Factorys-items {
          float: left;
          display: block;
          width: 24%;
          position: relative;
          height: 220px;
          margin-left: 1%;
          margin-top: 12px;
          box-sizing: border-box;
          .text {
            position: absolute;
            bottom: 0px;
            width: 100%;
            left: 0px;
            height: 38px;
            color: #fff;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            line-height: 38px;
          }
        }
      }
      .gsjs {
        transform: translate(0, 0px);
        opacity: 1;
        transition: 1.3s;
        -webkit-transition: 1.3s;
        .imgs {
          float: left;
          width: 420px;
          overflow: hidden;
        }
        .txts {
          float: right;
          width: calc(100% - 480px);
          line-height: 2em;
          font-size: 16px;
          color: #000000;
        }
        .txt {
          float: right;
          width: calc(100% - 480px);
          line-height: 1.5em;
        }
      }
      .pagetits {
        font-size: 22px;
        text-align: center;
        line-height: 1.2em;
        padding-bottom: 3%;
        color: #333333;
      }

      .pagetit {
        font-size: 22px;
        text-align: center;
        line-height: 1.2em;
        padding-bottom: 3.5%;
        color: #333333;
      }
    }
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
    }
  }
}
</style>
